import api from './api';

const employeeMasterService = {
  getAllEmployees: async (params = {}) => {
    try {
      const response = await api.get('/employee-master', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching all employee master records:', error);
      throw error;
    }
  },

  getEmployeeById: async (id) => {
    try {
      const response = await api.get(`/employee-master/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching employee master record with ID ${id}:`, error);
      throw error;
    }
  },

  getNextEmployeeCode: async () => {
    try {
      const response = await api.get('/employee-master/code/next');
      return response.data;
    } catch (error) {
      console.error('Error fetching next employee code:', error);
      throw error;
    }
  },

  createEmployee: async (employeeData) => {
    try {
      const response = await api.post('/employee-master', employeeData);
      return response.data;
    } catch (error) {
      console.error('Error creating employee master record:', error);
      throw error;
    }
  },

  updateEmployee: async (id, employeeData) => {
    try {
      const response = await api.put(`/employee-master/${id}`, employeeData);
      return response.data;
    } catch (error) {
      console.error(`Error updating employee master record with ID ${id}:`, error);
      throw error;
    }
  },

  deleteEmployee: async (id) => {
    try {
      const response = await api.delete(`/employee-master/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting employee master record with ID ${id}:`, error);
      throw error;
    }
  },

  getEmployeeStats: async () => {
    try {
      const response = await api.get('/employee-master/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching employee master stats:', error);
      throw error;
    }
  },

  getActiveEmployees: async () => {
    try {
      const response = await api.get('/employee-master/active');
      return response.data;
    } catch (error) {
      console.error('Error fetching active employees:', error);
      throw error;
    }
  },
};

export default employeeMasterService;

